



















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Selector from "../Selector.vue";
import { FullScreenModalOptions } from "../../../model/component.model";

@Component({
  components: {
    MbeSelector: Selector
  }
})
export default class FullScreenModal extends Vue {
  @Prop({})
  options: FullScreenModalOptions;

  created() {}

  closeModalDismiss() {
    this.$emit("close", { status: "dismiss" });
  }

  closeModalSuccess() {
    this.$emit("close", { status: "success" });
  }

  beforeCreate() {
    /**
     * Add a class that hide scrollbar when modal is open
     */
    document
      .getElementsByTagName("body")
      .item(0)
      .classList.add("modal-open");
  }
  destroyed() {
    /**
     * Remove a class that hide scrollbar when modal is open
     */
    document
      .getElementsByTagName("body")
      .item(0)
      .classList.remove("modal-open");
  }
}
